import { type EIP1474Methods } from 'viem';
import { z } from 'zod/v4';

import type { InfinexMessageNamespace } from './base';
import { targetTypeSchema } from './base';

import { errorEnvelopeSchema } from '../errors';

export type Eip1193Method = EIP1474Methods[number]['Method'];
export type Eip1193Params = EIP1474Methods[number]['Parameters'];
const namespace: InfinexMessageNamespace = 'eip1193';

// (No schemas to export because there are no methods in the original map.)
export const eip1193RequestParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.custom<EIP1474Methods[number]['Method']>(),
  data: z.custom<EIP1474Methods[number]['Parameters']>(),
  timeoutMs: z.number().optional(),
});

export const eip1193ResponseParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.custom<EIP1474Methods[number]['Method']>(),
  response: z.custom<EIP1474Methods[number]['ReturnType']>(),
  requestId: z.string(),
  error: z.optional(z.unknown()),
});

export const eip1193NotificationParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.custom<EIP1474Methods[number]['Method']>(),
  data: z.custom<EIP1474Methods[number]['Parameters']>(),
});

export const eip1193RequestPassthroughSchema = z.object({
  type: z.literal('eip1193:request'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  requestId: z.string(),
  method: z.custom<EIP1474Methods[number]['Method']>(),
  data: z.custom<EIP1474Methods[number]['Parameters']>(),
});

export const eip1193ResponsePassthroughSchema = z.object({
  type: z.literal('eip1193:response'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  requestId: z.string(),
  method: z.custom<EIP1474Methods[number]['Method']>(),
  response: z.custom<EIP1474Methods[number]['ReturnType']>(),
  error: z.optional(errorEnvelopeSchema),
});

export const eip1193NotificationPassthroughSchema = z.object({
  type: z.literal('eip1193:notification'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  timestamp: z.string(),
  method: z.custom<EIP1474Methods[number]['Method']>(),
  data: z.custom<EIP1474Methods[number]['Parameters']>(),
});
